import { useCallback, useEffect, useState } from "react";
import type { PostAsk } from "../api/contract";
import type { SentReference } from "./useReferences";

export type PostSelectionRequest = Extract<PostAsk, { intent: "rewrite" }>;
interface PendingSelection {
  context: string;
  request: PostSelectionRequest;
  onSent: () => void;
}

/** Selecting words prepares a request. Only submitting the owner's instruction sends it. */
export function usePostSelectionRequest(context: string, send: (text: string, attachments: SentReference[], post?: PostAsk) => boolean) {
  const [stored, setStored] = useState<PendingSelection | null>(null);
  const pending = stored?.context === context ? stored : null;
  useEffect(() => { setStored(null); }, [context]);
  const prepare = useCallback((request: PostSelectionRequest, onSent: () => void) => {
    setStored({ context, request, onSent });
  }, [context]);
  const cancel = useCallback(() => setStored(null), []);
  const submit = useCallback((text: string, attachments: SentReference[] = []) => {
    if (pending && !text.trim()) return false;
    if (!send(text, attachments, pending?.request)) return false;
    pending?.onSent();
    setStored(null);
    return true;
  }, [pending, send]);
  return { pending, prepare, cancel, submit };
}
